import { Planzone, Identifiable, StrategicAxis } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

function saveStrategicAxis(httpClient: HttpClient) {
  return (planzone: Identifiable<Planzone>, strategicAxis: StrategicAxis) =>
    new Promise<Identifiable<StrategicAxis>>((resolve, reject) =>
      httpClient
        .sendHttpRequest<Identifiable<StrategicAxis>>({
          endpoint: "/strategicAxeses",
          method: HttpMethods.POST,
          data: {
            planzone: `planzone/${planzone.uuid}`,
            ...strategicAxis,
          },
        })
        .then((strategicAxis) => strategicAxis)
        .then(resolve)
        .catch((e) => reject({ ...e, message: e.detail || "" })),
    );
}

export { saveStrategicAxis };
